import { Pipe, PipeTransform } from "@angular/core";

@Pipe({
    name: 'filterChildLength',
    pure: false,
    standalone: false
})
export class FilterLength implements PipeTransform {
    transform(items: any[], childField:string): any {
        if (!items ) {
            return items;
        }
        
        if ( items.length == 0){
            return items;
        }
        
        return items.filter(d=>d[childField].length > 0 );

    }

}